import { render, staticRenderFns } from "./UnscheduledPrograms.vue?vue&type=template&id=028a2fca&scoped=true"
import script from "./UnscheduledPrograms.vue?vue&type=script&lang=ts"
export * from "./UnscheduledPrograms.vue?vue&type=script&lang=ts"
import style0 from "./UnscheduledPrograms.vue?vue&type=style&index=0&id=028a2fca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028a2fca",
  null
  
)

export default component.exports